import { Link, Popover, Typography } from '@one-thd/sui-atomic-components';
import { PDF } from '@one-thd/sui-icons';
import React, { useState } from 'react';
export var InfoAndGuidesPopover = function (_a) {
    var documents = _a.documents, internetSKU = _a.internetSKU, modelNumber = _a.modelNumber, storeSKU = _a.storeSKU;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'info-guide-popover' : undefined;
    return (React.createElement("div", { className: "sui-mt-2" },
        React.createElement(Link, { variant: "body-base", component: "button", "aria-describedby": id, onClick: handleClick }, "Info & Guides"),
        React.createElement("div", { className: "sui-z-10" },
            React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, placement: "bottom", title: "Info & Guides", offset: "normal", "data-testid": "info-guide-popover", key: modelNumber, className: "sui-z-max" },
                React.createElement(Typography, { variant: "body-xs" },
                    "Model ",
                    modelNumber),
                React.createElement(Typography, { variant: "body-xs" },
                    "Internet #",
                    internetSKU),
                React.createElement(Typography, { variant: "body-xs" },
                    "Store SKU #",
                    storeSKU),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-2 sui-my-2" }, documents &&
                    (documents === null || documents === void 0 ? void 0 : documents.map(function (document, index) { return (React.createElement("div", { key: index, className: "sui-flex sui-gap-2 sui-align-middle" },
                        React.createElement(PDF, { size: "small" }),
                        React.createElement(Link, { target: "_blank", rel: "noreferrer noopener", href: document.url, variant: "body-xs", weight: "bold" }, document.name))); }))),
                documents && (React.createElement(Typography, { variant: "body-xs" }, "You will need Adobe Reader to view PDF documents."))))));
};
